import { render, staticRenderFns } from "./SalesOrderDetails.vue?vue&type=template&id=5ac69867&scoped=true&"
import script from "./SalesOrderDetails.vue?vue&type=script&lang=js&"
export * from "./SalesOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderDetails.vue?vue&type=style&index=0&id=5ac69867&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac69867",
  null
  
)

export default component.exports